import {
  isAgencyAdmin,
  isAgencyUser,
  isRolePlatformAdmin,
  token,
} from "../../../modules/auth";
import { isCompanyAdmin, isCompanyUser } from "../../../modules/permissions";
import { fetchHotelGroup, fetchSnapshotReport } from "../../../redux/actions";
import { connect } from "react-redux";
import React, { useState, useEffect } from "react";
import PreferredProgrammeOverrideForm from "../../../Components/PreferredProgrammes/PreferredProgrammeOverrideForm";
import { withRouter } from "react-router";
import Loading from "../../../Components/Loading";
let PreferredProgrammeCustomCreateContainer = ({
  groupId,
  hotelGroup,
  fetchHotelGroup,
  token,
  match,
}) => {
  const [loading, setLoading] = useState(false);
  const [programme, setProgramme] = useState(null);

  useEffect(() => {
    fetchHotelGroup(groupId, token, null, true);
  }, []);

  useEffect(() => {
    if (hotelGroup) {
      setProgramme(
        hotelGroup.programmes.find(
          p => parseInt(p.id) === parseInt(match.params.programme)
        )
      );
    }
  }, [hotelGroup]);

  if (!hotelGroup && !isRolePlatformAdmin) {
    return <Loading></Loading>;
  }
  return (
    <div>
      <div className="border-b border-gray-200 sm:rounded-lg bg-white p-5">
        <h1 className={"py-3"}>Create Custom Group</h1>
        <PreferredProgrammeOverrideForm
          hotelGroup={null}
          token={token}
          isCustomGroup={true}
          type={'Create'}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    ...state.hotelGroup,
    ...state.snapshotReport,
    token: token(state),
    isAgencyAdmin: isAgencyAdmin(state),
    isAgencyUser: isAgencyUser(state),
    isCompanyAdmin: isCompanyAdmin(state.auth),
    isCompanyUser: isCompanyUser(state.auth),
    isRolePlatformAdmin: isRolePlatformAdmin(state),
    groupId: props.match.params.id,
  };
};

const mapDispatchToProps = {
  fetchHotelGroup,
  fetchSnapshotReport,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PreferredProgrammeCustomCreateContainer)
);
